import { Box, Flex, Text } from '@chakra-ui/react';
import { CancelWaves, Container, DisplayHeading, Eyebrow } from '@/travo/components/ui/postmark';
import { useCopy, useLocale } from '@/travo/i18n';
import { HARD_SHADOW, PAPER_PATTERN } from '@/travo/theme/constants';

/**
 * zh mission heading: keep-all leaves one break point (after 「，」), so it always sets as
 * 11 + 12 full-width glyphs. 8cqi of the column keeps the 12-glyph line inside it at any width.
 */
const ZH_MISSION_SIZE = 'min(50px, 8cqi)';

/** The mission as a letter on ruled paper inside an airmail envelope. */
const MissionLetter = () => {
  const { about } = useCopy();
  const isZh = useLocale() === 'zh-TW';

  return (
    <Container as="section" pb={{ base: '80px', md: '112px' }}>
      <Box className="airmail" p="12px" boxShadow={HARD_SHADOW.card}>
        <Flex wrap="wrap" gap="48px" bg="card" p={{ base: '28px', md: '72px' }}>
          <Flex direction="column" gap="20px" flex="1 1 340px" minW={0} css={{ containerType: 'inline-size' }}>
            <Eyebrow>{about.missionEyebrow}</Eyebrow>
            <DisplayHeading fontSize={isZh ? ZH_MISSION_SIZE : { base: '32px', md: '50px' }} lineHeight="1.2">
              {about.missionLead}
              <Box as="span" color="stamp">
                {about.missionAccent}
              </Box>
              {about.missionTail}
            </DisplayHeading>
            <CancelWaves w="220px" h="50px" color="stamp" opacity={0.7} />
          </Flex>

          <Flex {...PAPER_PATTERN.ruled} direction="column" gap="38px" flex="1.3 1 420px" minW={0} lineHeight="38px" fontSize="17px">
            <Text fontFamily="mono" fontSize="14px" letterSpacing="0.08em">
              {about.salutation}
            </Text>
            {about.letter.map((paragraph, i) => (
              <Text key={i}>{paragraph}</Text>
            ))}
            <Text className="display" fontFamily="heading" fontWeight="900" fontSize="26px" color="stamp">
              {about.signature}
            </Text>
          </Flex>
        </Flex>
      </Box>
    </Container>
  );
};

export default MissionLetter;
